import Vue from 'vue';
import VuePortal from '@linusborg/vue-simple-portal';
Vue.use(VuePortal, {
    name: 'teleport', // for compatibility with Vue 3 teleport
});
